import { validateEmail } from '../Shared/validations.js';

const validate = values => {
    const errors = {
        ...validateEmail(values)
    };

    return errors;
};

export default validate;
